module.exports = __webpack_public_path__ + "media/concept.7808b0a6.mp4";